"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebhookStatus = exports.WebhookTopic = exports.DeliveryErrorCode = exports.ServiceAreaType = exports.OnfleetFailureCodes = exports.VehicleType = exports.DSPSoftware = exports.FleetSize = exports.DSPService = exports.DSPType = exports.SMSTemplateTags = exports.SMSType = exports.IScanEventType = exports.ISO2CodeToNamesMap = exports.CountryISO2 = exports.DATE_FORMAT = exports.IMerchantType = exports.IShopifyDiscountType = exports.PackageSize = exports.MonthlyVolume = exports.PackageWeight = exports.ZoneStatus = exports.ServiceAddOns = exports.Currencies = exports.IDataWarningType = exports.ITaskState = exports.ITaskType = exports.IEventType = exports.ITrackingEventSourceType = exports.TrackingEventState = exports.ApiTokenType = exports.IBatchState = exports.LANGUAGE = exports.ValidationEngine = exports.ISmartyStreetsPrecision = exports.CSVProcessingStatus = exports.LabelCreationMethod = exports.ServiceType = exports.PackageType = exports.OrganizationType = exports.UserType = exports.UserPermissions = exports.UserRoleOptions = exports.UserRoleOrganizations = exports.UserStatus = void 0;
var UserStatus;
(function (UserStatus) {
    /** User can use portal, default status for users */
    UserStatus["ACTIVE"] = "ACTIVE";
    /** User cannot use portal, org admins can change user status to inactive */
    UserStatus["INACTIVE"] = "INACTIVE";
})(UserStatus = exports.UserStatus || (exports.UserStatus = {}));
var UserRoleOrganizations;
(function (UserRoleOrganizations) {
    UserRoleOrganizations["MERCHANT"] = "merchant";
    UserRoleOrganizations["DSP"] = "dsp";
})(UserRoleOrganizations = exports.UserRoleOrganizations || (exports.UserRoleOrganizations = {}));
var UserRoleOptions;
(function (UserRoleOptions) {
    UserRoleOptions["ADMIN"] = "admin";
    UserRoleOptions["MEMBER"] = "member";
})(UserRoleOptions = exports.UserRoleOptions || (exports.UserRoleOptions = {}));
var UserPermissions;
(function (UserPermissions) {
    UserPermissions["ADMIN"] = "ADMIN";
    UserPermissions["SUPERADMIN"] = "SUPERADMIN";
})(UserPermissions = exports.UserPermissions || (exports.UserPermissions = {}));
var UserType;
(function (UserType) {
    UserType["MERCHANT"] = "MERCHANT";
    UserType["MERCHANT_GROUP"] = "MERCHANT_GROUP";
    UserType["WAREHOUSE"] = "WAREHOUSE";
    UserType["GATSBY"] = "GATSBY";
    UserType["INTERNAL"] = "INTERNAL";
    UserType["DRIVER"] = "DRIVER";
    UserType["DRIVER_UNMANAGED"] = "DRIVER_UNMANAGED";
    UserType["WAREHOUSE_UNMANAGED"] = "WAREHOUSE_UNMANAGED";
})(UserType = exports.UserType || (exports.UserType = {}));
var OrganizationType;
(function (OrganizationType) {
    OrganizationType["DSP"] = "DSP";
    OrganizationType["_3PL"] = "3PL";
    OrganizationType["CROSSDOCK"] = "crossdock";
    OrganizationType["MERCHANT"] = "merchant";
    OrganizationType["SWYFT"] = "swyft";
})(OrganizationType = exports.OrganizationType || (exports.OrganizationType = {}));
/**
 * Not every customer has a different rate for different package size. We go
 * with default option and if the default isn't provided then we go bottom up
 * (check large, then check medium, then check small)
 */
var PackageType;
(function (PackageType) {
    PackageType["DEFAULT"] = "DEFAULT";
    PackageType["SMALL"] = "SMALL";
    PackageType["MEDIUM"] = "MEDIUM";
    PackageType["LARGE"] = "LARGE";
    PackageType["EXTRA_LARGE"] = "EXTRA_LARGE";
})(PackageType = exports.PackageType || (exports.PackageType = {}));
var ServiceType;
(function (ServiceType) {
    ServiceType["SAME_DAY"] = "SAMEDAY";
    ServiceType["NEXT_DAY"] = "NEXTDAY";
})(ServiceType = exports.ServiceType || (exports.ServiceType = {}));
var LabelCreationMethod;
(function (LabelCreationMethod) {
    LabelCreationMethod["API"] = "API";
    LabelCreationMethod["FTP"] = "FTP";
    LabelCreationMethod["SHOPIFY"] = "SHOPIFY";
    LabelCreationMethod["MERCHANT_DASHBOARD"] = "MERCHANT_DASHBOARD";
    LabelCreationMethod["OPERATIONS_DASHBOARD"] = "OPERATIONS_DASHBOARD";
})(LabelCreationMethod = exports.LabelCreationMethod || (exports.LabelCreationMethod = {}));
/**
 * @deprecated We longer use this field for CSVs
 */
var CSVProcessingStatus;
(function (CSVProcessingStatus) {
    CSVProcessingStatus["INCOMPLETE"] = "INCOMPLETE";
    CSVProcessingStatus["PENDING"] = "PENDING";
    CSVProcessingStatus["RETRYING"] = "RETRYING";
    CSVProcessingStatus["PROCESSING"] = "PROCESSING";
    CSVProcessingStatus["COMPLETED"] = "COMPLETED";
    CSVProcessingStatus["FAILED"] = "FAILED";
})(CSVProcessingStatus = exports.CSVProcessingStatus || (exports.CSVProcessingStatus = {}));
/**
 * Smarty Streets precision options
 * Metric from SS to estimate the accuracy of either the geocode lookup or the address validation.
 * These are ordered by accuracy, for example, "Manual" and "DeliveryPoint" are the most accurate and "None" is least accurate.
 * See https://smartystreets.com/docs/cloud/international-street-api for more details.
 * Option "Manual" is for manual geocodes from the dashboard. These are assumed to be highest accuracy because
 * we expect ops to fill in the correct geocode here.
 */
var ISmartyStreetsPrecision;
(function (ISmartyStreetsPrecision) {
    ISmartyStreetsPrecision["MANUAL"] = "Manual";
    ISmartyStreetsPrecision["DELIVERY_POINT"] = "DeliveryPoint";
    ISmartyStreetsPrecision["PREMISE"] = "Premise";
    ISmartyStreetsPrecision["THOROUGHFARE"] = "Thoroughfare";
    ISmartyStreetsPrecision["LOCALITY"] = "Locality";
    ISmartyStreetsPrecision["ADMINISTRATIVE_AREA"] = "AdministrativeArea";
    ISmartyStreetsPrecision["NONE"] = "None";
})(ISmartyStreetsPrecision = exports.ISmartyStreetsPrecision || (exports.ISmartyStreetsPrecision = {}));
/**
 * We have multiple validation engine options. This enum is collection of them.
 */
var ValidationEngine;
(function (ValidationEngine) {
    ValidationEngine["SMARTY"] = "SMARTY";
    ValidationEngine["GOOGLE"] = "GOOGLE";
})(ValidationEngine = exports.ValidationEngine || (exports.ValidationEngine = {}));
var LANGUAGE;
(function (LANGUAGE) {
    LANGUAGE["ENGLISH"] = "ENG";
    LANGUAGE["FRENCH"] = "FRE";
})(LANGUAGE = exports.LANGUAGE || (exports.LANGUAGE = {}));
/**
 * Enum to keep track of the batch state. Possible values:
 * ENQUEUED - means that batch is in the queue and waiting for the worker
 * PROCESSING - worker picked up the batch and is processing it (creating tasks, updating db, etc)
 * COMPLETED - batch completed successfully, tasks are created or already exist for all of the labels
 * COMPLETED_WITH_FAILURES - tasks for some of the labels are created successfully, but for some
 * of them we had a errorresponse from the OnFleet (field related errors, validations, etc).
 * FAILED - worker function call errored out for some reason
 */
var IBatchState;
(function (IBatchState) {
    IBatchState["ENQUEUED"] = "ENQUEUED";
    IBatchState["PROCESSING"] = "PROCESSING";
    IBatchState["COMPLETED"] = "COMPLETED";
    IBatchState["COMPLETED_WITH_FAILURES"] = "COMPLETED_WITH_FAILURES";
    IBatchState["FAILED"] = "FAILED";
})(IBatchState = exports.IBatchState || (exports.IBatchState = {}));
var ApiTokenType;
(function (ApiTokenType) {
    ApiTokenType["LIVE"] = "LIVE";
    ApiTokenType["SANDBOX"] = "SANDBOX";
})(ApiTokenType = exports.ApiTokenType || (exports.ApiTokenType = {}));
var TrackingEventState;
(function (TrackingEventState) {
    /** Swyft created label */
    TrackingEventState["PENDING"] = "PENDING";
    /** OnFleet task created (updates label via webhook) */
    TrackingEventState["CONFIRMED"] = "CONFIRMED";
    /** OnFleet task assigned to driver (updates label via webhook) */
    TrackingEventState["ASSIGNED"] = "ASSIGNED";
    /** Swyft scans the label at the warehouse */
    TrackingEventState["RECEIVED"] = "RECEIVED";
    /** OnFleet task started (initiated by the driver) */
    TrackingEventState["IN_TRANSIT"] = "IN_TRANSIT";
    /** OnFleet geolocation trigger (driver is near destination) */
    TrackingEventState["ARRIVING"] = "ARRIVING";
    /** OnFleet completes task (driver completes the task) */
    TrackingEventState["DELIVERED"] = "DELIVERED";
    /** OnFleet fails task (driver fails delivery) */
    TrackingEventState["FAILED"] = "FAILED";
    /** Swyft deletes the label */
    TrackingEventState["DELETED"] = "DELETED";
    /** If the label.redeliveryAttempts is less than 3, it will be put into this temporary state */
    TrackingEventState["SCHEDULED_FOR_REDELIVERY"] = "SCHEDULED_FOR_REDELIVERY";
    /** If the label.redeliveryAttempts is greater than 3, it will be put into this temporary state */
    TrackingEventState["RETURNING_TO_SENDER"] = "RETURNING_TO_SENDER";
    /** The package has been returned to sender*/
    TrackingEventState["RETURNED_TO_SENDER"] = "RETURNED_TO_SENDER";
    /** The package was not received from the merchant */
    TrackingEventState["NOT_RECEIVED"] = "NOT_RECEIVED";
    /** There was an issue with the package and it is being triaged */
    TrackingEventState["PROBLEM"] = "PROBLEM";
    /** The package is in storage and will be sent out at a later date */
    TrackingEventState["STORAGE"] = "STORAGE";
})(TrackingEventState = exports.TrackingEventState || (exports.TrackingEventState = {}));
var ITrackingEventSourceType;
(function (ITrackingEventSourceType) {
    ITrackingEventSourceType["DASHBOARD"] = "DASHBOARD";
    ITrackingEventSourceType["SWYFT"] = "SWYFT";
    ITrackingEventSourceType["ONFLEET"] = "ONFLEET";
})(ITrackingEventSourceType = exports.ITrackingEventSourceType || (exports.ITrackingEventSourceType = {}));
var IEventType;
(function (IEventType) {
    IEventType["CREATE"] = "CREATE";
    IEventType["DELETE"] = "DELETE";
    IEventType["UPDATE"] = "UPDATE";
    IEventType["UPDATE_SHIP_DATE"] = "UPDATE_SHIP_DATE";
    IEventType["ADDRESS_VERIFICATION"] = "ADDRESS_VERIFICATION";
    IEventType["ADDRESS_MANUAL_APPROVAL"] = "ADDRESS_MANUAL_APPROVAL";
    IEventType["SYNC_TO_ONFLEET"] = "SYNC_TO_ONFLEET";
    IEventType["UNASSIGN_ONFLEET_TASK"] = "UNASSIGN_ONFLEET_TASK";
    IEventType["RESCHEDULE_ONFLEET_TASK"] = "RESCHEDULE_ONFLEET_TASK";
    IEventType["RETURN_TO_MERCHANT"] = "RETURN_TO_MERCHANT";
})(IEventType = exports.IEventType || (exports.IEventType = {}));
var ITaskType;
(function (ITaskType) {
    ITaskType["PICKUP"] = "PICKUP";
    ITaskType["DROPOFF"] = "DROPOFF";
})(ITaskType = exports.ITaskType || (exports.ITaskType = {}));
var ITaskState;
(function (ITaskState) {
    ITaskState["PENDING"] = "PENDING";
    ITaskState["SCHEDULED"] = "SCHEDULED";
    ITaskState["COMPLETED"] = "COMPLETED";
    ITaskState["FAILED"] = "FAILED";
    ITaskState["CANCELLED"] = "CANCELLED";
})(ITaskState = exports.ITaskState || (exports.ITaskState = {}));
var IDataWarningType;
(function (IDataWarningType) {
    IDataWarningType["MISSING_PHONE_NUMBER"] = "MISSING_PHONE_NUMBER";
    IDataWarningType["DESTINATION_OUTSIDE_FSA"] = "DESTINATION_OUTSIDE_FSA";
    IDataWarningType["DUPLICATE_LABEL"] = "DUPLICATE_LABEL";
})(IDataWarningType = exports.IDataWarningType || (exports.IDataWarningType = {}));
var Currencies;
(function (Currencies) {
    Currencies["CAD"] = "CAD";
    Currencies["USD"] = "USD";
})(Currencies = exports.Currencies || (exports.Currencies = {}));
/** Delivery service add ons supported by us */
var ServiceAddOns;
(function (ServiceAddOns) {
    ServiceAddOns["SIGNATURE"] = "SIGNATURE";
    ServiceAddOns["CHECK_ID"] = "CHECK_ID";
    ServiceAddOns["XL_PACKAGE"] = "XL_PACKAGE";
    ServiceAddOns["ADDRESS_CORRECTION"] = "ADDRESS_CORRECTION";
    ServiceAddOns["RELABELLING_FEE"] = "RELABELLING_FEE";
    ServiceAddOns["WAITING_FEE"] = "WAITING_FEE";
})(ServiceAddOns = exports.ServiceAddOns || (exports.ServiceAddOns = {}));
var ZoneStatus;
(function (ZoneStatus) {
    ZoneStatus["ACTIVE"] = "ACTIVE";
    ZoneStatus["PENDING"] = "PENDING";
})(ZoneStatus = exports.ZoneStatus || (exports.ZoneStatus = {}));
var PackageWeight;
(function (PackageWeight) {
    PackageWeight["VERY_LIGHT"] = "VERY_LIGHT";
    PackageWeight["LIGHT"] = "LIGHT";
    PackageWeight["MEDIUM"] = "MEDIUM";
    PackageWeight["HEAVY"] = "HEAVY";
    PackageWeight["V1_HEAVY"] = "V1_HEAVY";
    PackageWeight["V2_HEAVY"] = "V2_HEAVY";
    PackageWeight["V3_HEAVY"] = "V3_HEAVY";
    PackageWeight["V4_HEAVY"] = "V4_HEAVY";
})(PackageWeight = exports.PackageWeight || (exports.PackageWeight = {}));
var MonthlyVolume;
(function (MonthlyVolume) {
    MonthlyVolume["VERY_SMALL"] = "VERY_SMALL";
    MonthlyVolume["SMALL"] = "SMALL";
    MonthlyVolume["MEDIUM"] = "MEDIUM";
    MonthlyVolume["LARGE"] = "LARGE";
    MonthlyVolume["EXTRA_LARGE"] = "EXTRA_LARGE";
})(MonthlyVolume = exports.MonthlyVolume || (exports.MonthlyVolume = {}));
var PackageSize;
(function (PackageSize) {
    PackageSize["BAG"] = "BAG";
    PackageSize["SMALL"] = "SMALL";
    PackageSize["MEDIUM"] = "MEDIUM";
    PackageSize["LARGE"] = "LARGE";
    PackageSize["EXTRA_LARGE"] = "EXTRA_LARGE";
})(PackageSize = exports.PackageSize || (exports.PackageSize = {}));
/**
 * Specifies the type of discount to apply if enabled.
 * cartValueFlatDiscount (FLAT) or cartValueDiscountPercent (PERCENTAGE)
 * */
var IShopifyDiscountType;
(function (IShopifyDiscountType) {
    IShopifyDiscountType["FLAT"] = "FLAT";
    IShopifyDiscountType["PERCENTAGE"] = "PERCENTAGE";
})(IShopifyDiscountType = exports.IShopifyDiscountType || (exports.IShopifyDiscountType = {}));
/** Merchant types */
var IMerchantType;
(function (IMerchantType) {
    IMerchantType["ENTERPRISE"] = "ENTERPRISE";
    IMerchantType["SMB"] = "SMB";
    /** The customers that pick and pack items for merchants */
    IMerchantType["THIRD_PARTY_LOGISTICS"] = "THIRD_PARTY_LOGISTICS";
    /** The customers of the 3PL */
    IMerchantType["THIRD_PARTY_LOGISTICS_MERCHANT"] = "THIRD_PARTY_LOGISTICS_MERCHANT";
})(IMerchantType = exports.IMerchantType || (exports.IMerchantType = {}));
var DATE_FORMAT;
(function (DATE_FORMAT) {
    /** Formatted date example: 2020-12-31 */
    DATE_FORMAT["SHIP_DATE"] = "YYYY-MM-DD";
    /** Formatted date example: Apr 21, 2021 */
    DATE_FORMAT["READABLE_SHIP_DATE"] = "MMM DD, YYYY";
    /** Formatted date example: 09:30 AM */
    DATE_FORMAT["CUT_OFF_TIME"] = "hh:mm A";
    /** Formatted date example: April 21st 2021 */
    DATE_FORMAT["LABEL_PDF"] = "MMMM Do YYYY";
    /** Formatted date example: 9:30 AM, 22 Apr 2021 */
    DATE_FORMAT["READABLE_TIMESTAMP"] = "h:mm A, DD MMM YYYY";
    /** Formatted date example: 09:30 AM */
    DATE_FORMAT["ROUTING_ENGINE"] = "hh:mm A";
})(DATE_FORMAT = exports.DATE_FORMAT || (exports.DATE_FORMAT = {}));
var CountryISO2;
(function (CountryISO2) {
    CountryISO2["USA"] = "US";
    CountryISO2["CANADA"] = "CA";
})(CountryISO2 = exports.CountryISO2 || (exports.CountryISO2 = {}));
exports.ISO2CodeToNamesMap = (_a = {},
    _a[CountryISO2.USA] = new Set([
        "united states of america",
        "usa",
        "united states",
        "us",
    ]),
    _a[CountryISO2.CANADA] = new Set(["canada", "can", "ca"]),
    _a);
/** Specifies different kinds of scans that can take place */
var IScanEventType;
(function (IScanEventType) {
    /** Package was scanned when scanner app is in received mode */
    IScanEventType["ARRIVAL_SCAN"] = "ARRIVAL_SCAN";
    /** Package was scanned when scanner app is in sortation mode */
    IScanEventType["SORT_SCAN"] = "SORT_SCAN";
    /** Package scanned in read only mode */
    IScanEventType["READ_ONLY_SCAN"] = "READ_ONLY_SCAN";
    /** Package scanned by gatsby */
    IScanEventType["GATSBY_SCAN"] = "GATSBY_SCAN";
    /** Package scanned by a driver */
    IScanEventType["DRIVER_SCAN"] = "DRIVER_SCAN";
})(IScanEventType = exports.IScanEventType || (exports.IScanEventType = {}));
/** Specifications of different types of SMS events */
var SMSType;
(function (SMSType) {
    SMSType["SCHEDULED_FOR_DELIVERY"] = "SCHEDULED_FOR_DELIVERY";
    SMSType["NEXT_FOR_DELIVERY"] = "NEXT_FOR_DELIVERY";
    SMSType["ARRIVING"] = "ARRIVING";
    SMSType["DELIVERED"] = "DELIVERED";
    SMSType["DELIVERED_SURVEY"] = "DELIVERED_SURVEY";
    SMSType["FAILED"] = "FAILED";
    SMSType["SCHEDULED_FOR_REDELIVERY"] = "SCHEDULED_FOR_REDELIVERY";
    SMSType["RETURNING_TO_SENDER"] = "RETURNING_TO_SENDER";
    SMSType["RECEIVED"] = "RECEIVED";
    SMSType["ERROR"] = "ERROR";
})(SMSType = exports.SMSType || (exports.SMSType = {}));
var SMSTemplateTags;
(function (SMSTemplateTags) {
    SMSTemplateTags["firstName"] = "{firstName}";
    SMSTemplateTags["businessName"] = "{businessName}";
    SMSTemplateTags["estimatedDeliveryTime"] = "{estimatedDeliveryTime}";
    SMSTemplateTags["trackingUrl"] = "{trackingUrl}";
    SMSTemplateTags["pastDeliveryAttemptDate"] = "{pastDeliveryAttemptDate}";
})(SMSTemplateTags = exports.SMSTemplateTags || (exports.SMSTemplateTags = {}));
var DSPType;
(function (DSPType) {
    DSPType["LOCAL"] = "Local Courier";
    DSPType["REGIONAL"] = "Regional Carrier";
    DSPType["MAJOR"] = "Major Carrier";
})(DSPType = exports.DSPType || (exports.DSPType = {}));
var DSPService;
(function (DSPService) {
    DSPService["PICKUP"] = "PICKUP";
    DSPService["SORT"] = "SORT";
    DSPService["DELIVERY"] = "DELIVERY";
    DSPService["STORAGE"] = "STORAGE";
    DSPService["MIDMILE"] = "MIDMILE";
})(DSPService = exports.DSPService || (exports.DSPService = {}));
var FleetSize;
(function (FleetSize) {
    FleetSize["SMALL"] = "SMALL";
    FleetSize["MEDIUM"] = "MEDIUM";
    FleetSize["LARGE"] = "LARGE";
    FleetSize["EXTRA_LARGE"] = "EXTRA_LARGE";
})(FleetSize = exports.FleetSize || (exports.FleetSize = {}));
var DSPSoftware;
(function (DSPSoftware) {
    DSPSoftware["XCELERATOR"] = "Xcelerator";
    DSPSoftware["CXT"] = "CXT";
    DSPSoftware["ECOURIER"] = "Ecourier";
    DSPSoftware["OTHER"] = "Other";
})(DSPSoftware = exports.DSPSoftware || (exports.DSPSoftware = {}));
/**
 * Vehicle our drivers use (inferred from onfleet)
 * See @onfleet/node-onfleet/Resources/Workers for more details
 */
var VehicleType;
(function (VehicleType) {
    VehicleType["CAR"] = "CAR";
    VehicleType["TRUCK"] = "TRUCK";
    VehicleType["UNKNOWN"] = "UNKNOWN";
})(VehicleType = exports.VehicleType || (exports.VehicleType = {}));
/** Onfleet failure reasons that drivers can choose when failing a task */
var OnfleetFailureCodes;
(function (OnfleetFailureCodes) {
    OnfleetFailureCodes["OTHER"] = "OTHER";
    OnfleetFailureCodes["UNABLE_TO_LOCATE"] = "UNABLE_TO_LOCATE";
    OnfleetFailureCodes["ITEM_DAMAGED"] = "ITEM_DAMAGED";
    OnfleetFailureCodes["ITEM_INCORRECT"] = "ITEM_INCORRECT";
    OnfleetFailureCodes["UNAVAILABLE"] = "UNAVAILABLE";
    OnfleetFailureCodes["DESTINATION_INCORRECT"] = "DESTINATION_INCORRECT";
    OnfleetFailureCodes["DELIVERY_INCIDENT"] = "DELIVERY_INCIDENT";
})(OnfleetFailureCodes = exports.OnfleetFailureCodes || (exports.OnfleetFailureCodes = {}));
/** Types of the service areas our system supports */
var ServiceAreaType;
(function (ServiceAreaType) {
    /** areas which we provide service */
    ServiceAreaType["INCLUSION"] = "INCLUSION";
    /** areas inside inclusion areas which we do not provide service */
    ServiceAreaType["EXCLUSION"] = "EXCLUSION";
})(ServiceAreaType = exports.ServiceAreaType || (exports.ServiceAreaType = {}));
/** Internal error codes inputted by a driver through onFleet as part of notes section */
var DeliveryErrorCode;
(function (DeliveryErrorCode) {
    DeliveryErrorCode["NO_ACCESS_COMMERCIAL_ADDRESS"] = "NO_ACCESS_COMMERCIAL_ADDRESS";
    DeliveryErrorCode["NO_ACCESS_RESIDENTIAL_ADDRESS"] = "NO_ACCESS_RESIDENTIAL_ADDRESS";
    DeliveryErrorCode["UNABLE_TO_COLLECT_SIGNATURE"] = "UNABLE_TO_COLLECT_SIGNATURE";
    DeliveryErrorCode["CUSTOMER_REFUSED_DELIVERY"] = "CUSTOMER_REFUSED_DELIVERY";
    DeliveryErrorCode["INCORRECT_CUSTOMER_ADDRESS"] = "INCORRECT_CUSTOMER_ADDRESS";
    DeliveryErrorCode["MISSING_PACKAGE"] = "MISSING_PACKAGE";
    DeliveryErrorCode["DRIVER_ACCIDENT"] = "DRIVER_ACCIDENT";
    DeliveryErrorCode["ITEM_DAMAGED"] = "ITEM_DAMAGED";
    DeliveryErrorCode["PAST_DELIVERY_WINDOW"] = "PAST_DELIVERY_WINDOW";
    DeliveryErrorCode["NO_SPACE_IN_CAR"] = "NO_SPACE_IN_CAR";
    DeliveryErrorCode["OTHER"] = "OTHER";
})(DeliveryErrorCode = exports.DeliveryErrorCode || (exports.DeliveryErrorCode = {}));
var WebhookTopic;
(function (WebhookTopic) {
    WebhookTopic["TRACK_LABEL_UPDATES"] = "TRACK_LABEL_UPDATES";
})(WebhookTopic = exports.WebhookTopic || (exports.WebhookTopic = {}));
var WebhookStatus;
(function (WebhookStatus) {
    WebhookStatus["ACTIVE"] = "ACTIVE";
    WebhookStatus["INACTIVE"] = "INACTIVE";
})(WebhookStatus = exports.WebhookStatus || (exports.WebhookStatus = {}));
//# sourceMappingURL=types.js.map